import { useCallback, useEffect } from 'react';

export const useGlobalKeyDown = (
  callback: (evt: KeyboardEvent) => void,
  key: KeyboardEvent['key'],
) => {
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === key) {
        callback(event);
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [callback, key]);
};

export const useEscapeBlur = () => {
  const handleKeydown = useCallback((e: React.KeyboardEvent) => {
    e.stopPropagation();

    if (e.target && e.key === 'Escape') {
      (e.target as HTMLInputElement).blur();
    }
  }, []);

  return { handleKeydown };
};
